import { Component, ViewChild } from '@angular/core';
import { IonicPage, Nav, NavController, NavParams, Events, Tabs } from 'ionic-angular';

import { HomePage,PortalPage,ProfilPage, Aproval } from '../';

import { DashboardPage as HomeProject } from '../../project_mobile/index';
import { HomePage as HomeAdvance } from '../../advance_mobile/index';
import { UserMyRadiant } from '../../../providers';

// @IonicPage()
@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html'
})
export class TabsPage {
  
  @ViewChild('myRadiantTabs') tabRef: Tabs;

  tab1Root: any = HomePage;
  tab2Root: any = PortalPage;
  tab3Root: any = ProfilPage;
  tab4Root: any = Aproval;

  tab1Title = " ";
  tab2Title = " ";
  tab3Title = " ";
  mySelectedIndex :number = 0;
  
  isLogin = false;
  has_fitur_approval = false;

  constructor(public navCtrl: NavController,public nav : Nav,public navParams : NavParams, public events : Events,private userApi : UserMyRadiant
   ) {
    // this.isLogin = localStorage.getItem('is_login') == '1' ? true : false;
    this.mySelectedIndex = this.navParams['data']['tabIndex'];
    if("approve_edit_employee" in this.userApi.akses){
      this.has_fitur_approval = true;
    }
    
    this.events.subscribe('user:has_set_fitur',() => {
      if("approve_edit_employee" in this.userApi.akses){
        this.has_fitur_approval = true;
      } 
    });
    this.events.subscribe('user:sign_out', () => {
      this.isLogin = false;
      this.has_fitur_approval = false;
      this.userApi.akses = [];
    });

  }


  goTo(menu){
    switch (menu) {
      case 'advance':
          this.nav.push(HomeAdvance);
        break;
      case 'project':
          this.nav.push(HomeProject);
        break;
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/tabs/tabs.ts